Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var types_1 = require("./types");
exports.initPanesNamespaceAction = function (namespace) { return typesafe_actions_1.action(types_1.PanesActionTypes.INIT_PANES_NAMESPACE, {
    namespace: namespace,
}); };
exports.setCurrentPaneAction = function (namespace, paneId) { return typesafe_actions_1.action(types_1.PanesActionTypes.SET_CURRENT_PANE, {
    namespace: namespace,
    paneId: paneId,
}); };
exports.addContentToCurrentPaneAction = function (namespace, content) { return typesafe_actions_1.action(types_1.PanesActionTypes.ADD_CONTENT_TO_CURRENT_PANE, {
    namespace: namespace,
    content: content,
}); };
exports.setPaneCurrentContentAction = function (namespace, paneId, contentId) { return typesafe_actions_1.action(types_1.PanesActionTypes.SET_PANE_CURRENT_CONTENT, {
    namespace: namespace,
    paneId: paneId,
    contentId: contentId,
}); };
exports.removePaneContentAction = function (namespace, paneId, contentId) { return typesafe_actions_1.action(types_1.PanesActionTypes.REMOVE_PANE_CONTENT, {
    namespace: namespace,
    paneId: paneId,
    contentId: contentId,
}); };
exports.removeContentFromAllPanesAction = function (namespace, contentId) { return typesafe_actions_1.action(types_1.PanesActionTypes.REMOVE_CONTENT_FROM_ALL_PANES, {
    namespace: namespace,
    contentId: contentId,
}); };
exports.splitPaneAction = function (namespace, paneId, axis) { return typesafe_actions_1.action(types_1.PanesActionTypes.SPLIT_PANE, {
    namespace: namespace,
    paneId: paneId,
    axis: axis,
}); };
exports.actionsFactory = function (namespace) { return ({
    initPanesNamespace: function () { return typesafe_actions_1.action(types_1.PanesActionTypes.INIT_PANES_NAMESPACE, {
        namespace: namespace
    }); },
    setCurrentPane: function (paneId) { return exports.setCurrentPaneAction(namespace, paneId); },
    addContentToCurrentPane: function (content) { return exports.addContentToCurrentPaneAction(namespace, content); },
    setPaneCurrentContent: function (paneId, contentId) { return exports.setPaneCurrentContentAction(namespace, paneId, contentId); },
    removePaneContent: function (paneId, contentId) { return exports.removePaneContentAction(namespace, paneId, contentId); },
    removeContentFromAllPanes: function (contentId) { return exports.removeContentFromAllPanesAction(namespace, contentId); },
    splitPane: function (paneId, axis) { return exports.splitPaneAction(namespace, paneId, axis); },
}); };
